// PreviewTester/utils/helpers.js
export const flattenObject = (obj, prefix = "") => {
  console.log('[DEBUG] flattenObject called with:', { obj, prefix });
  let result = {};
  for (let key in obj) {
    if (!obj.hasOwnProperty(key)) continue;
    const newKey = prefix ? `${prefix}.${key}` : key;
    const val = obj[key];
    if (val && typeof val === "object" && !Array.isArray(val)) {
      Object.assign(result, flattenObject(val, newKey));
    } else {
      result[newKey] = val;
    }
  }
  console.log('[DEBUG] flattenObject result:', result);
  return result;
};

export const isArrayData = (data) => {
  console.log('[DEBUG] isArrayData called with:', data);
  try {
    const parsed = JSON.parse(data);
    const result = Array.isArray(parsed);
    console.log('[DEBUG] isArrayData result:', result);
    return result;
  } catch {
    console.log('[DEBUG] isArrayData error - not valid JSON');
    return false;
  }
};

export const safeJSONParse = (text) => {
  console.log('[DEBUG] safeJSONParse called with:', text);
  try {
    const result = JSON.parse(text);
    console.log('[DEBUG] safeJSONParse result:', result);
    return result;
  } catch {
    console.log('[DEBUG] safeJSONParse error - not valid JSON');
    return null;
  }
};

export const deepMerge = (target, source) => {
  console.log('[DEBUG] deepMerge called with:', { target, source });
  const result = { ...target };
  for (const key in source) {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
      result[key] = deepMerge(result[key] || {}, source[key]);
    } else {
      result[key] = source[key];
    }
  }
  console.log('[DEBUG] deepMerge result:', result);
  return result;
};

// Check if any child is active
export const hasActiveChild = (children) => {
  if (!children || children.length === 0) return false;
  for (const child of children) {
    if (child.values && child.values.some(v => v.isActive)) return true;
    if (hasActiveChild(child.children)) return true;
  }
  return false;
};